import { Component } from "react";
import "./styles/PromineoDataGrid.css";
import { IDataGridOptions } from "devextreme-react/data-grid";
import PromineoBaseDataGrid, { GridOptions } from "./PromineoBaseDataGrid";

export default class PromineoDataGrid extends Component<GridOptions> {
  constructor(props: GridOptions) {
    super(props);
    this.state = {};
  }

  defaultGridOptions: IDataGridOptions = {
    showBorders: false,
    showRowLines: false,
    showColumnLines: false,
  };

  render() {
    const { gridRef, dataGridOptions, children } = this.props;
    return (
      <PromineoBaseDataGrid
        dataGridOptions={{...this.defaultGridOptions, ...dataGridOptions}}
        gridRef={gridRef}
        classNames={`promineo-datagrid ${this.props.classNames ?? ""}`}
      >{children}</PromineoBaseDataGrid>
    );
  }
}
